import React, { useState } from "react";
import { Card, Table, Form, Row, Col, Dropdown } from "react-bootstrap";

const initialData = [
  {
    id: 1,
    name: "Anthony Lewis",
    img: "/assets/img/users/user-11-1.jpg",
    role: "Accountant",
    course: "Git Training",
    status: "Completed",
    score: "80",
    date: "14 Jun 2025",
    feedback: "Good",
    attempts: "01",
    certificate: "Issued",
  },
  {
    id: 2,
    name: "Brian Villalobos",
    img: "/assets/img/users/user-13.jpg",
    role: "App Developer",
    course: "HTML Training",
    status: "In Progress",
  },
  {
    id: 3,
    name: "Harvey Smith",
    img: "/assets/img/users/user-12.jpg",
    role: "Technician",
    course: "React Training",
    status: "Not Started",
  },
  {
    id: 4,
    name: "Stephan Peralt",
    img: "/assets/img/users/user-16.jpg",
    role: "Web Developer",
    course: "Nodejs Training",
    status: "Completed",
    score: "90",
    date: "28 Apr 2025",
    feedback: "Excellent",
    attempts: "02",
    certificate: "Issued",
  },
];

export default function LearningEmployeeList() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);

  const filtered = data
    .filter((d) =>
      d.name.toLowerCase().includes(search.toLowerCase())
    )
    .slice(0, rows);

  const getStatusStyle = (status) => {
    switch (status) {
      case "Completed":
        return { background: "#dcfce7", color: "#16a34a" };
      case "In Progress":
        return { background: "#dbeafe", color: "#2563eb" };
      case "Not Started":
        return { background: "#f3e8ff", color: "#9333ea" };
      default:
        return {};
    }
  };

  return (
    <Card className="mt-4" style={{ borderRadius: "5px" }}>
      {/* HEADER */}
      <Card.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          background: "#fff",
        }}
      >
        <h5 style={{ fontWeight: 600 }}>
          Learning Employee List
        </h5>

        <Dropdown>
          <Dropdown.Toggle className="border border-2 text-dark bg-white">
            Sort By : Last 7 Days
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item>Ascending</Dropdown.Item>
            <Dropdown.Item>Descending</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body>
        {/* FILTER */}
        <Row className="mb-3">
          <Col md={6}>
            Row Per Page{" "}
            <Form.Select
              value={rows}
              onChange={(e) => setRows(Number(e.target.value))}
              style={{ width: 80, display: "inline-block" }}
            >
              <option>5</option>
              <option>10</option>
              <option>20</option>
            </Form.Select>{" "}
            Entries
          </Col>

          <Col md={6} className="text-md-end mt-2 mt-md-0">
            <Form.Control
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ maxWidth: 250, display: "inline-block" }}
            />
          </Col>
        </Row>

        {/* TABLE */}
        <div className="table-responsive">
          <Table hover>
            <thead style={{ background: "#f8fafc" }}>
              <tr>
                <th><Form.Check /></th>
                <th>Employee Name</th>
                <th>Designation</th>
                <th>Training Course</th>
                <th>Status</th>
                <th>Score(%)</th>
                <th>Completion Date</th>
                <th>Feedback</th>
                <th>Attempts</th>
                <th>Certificate</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item) => (
                <tr key={item.id}>
                  <td><Form.Check /></td>

                  {/* NAME */}
                  <td>
                    <div style={rowFlex}>
                      <img src={item.img} style={avatar} />
                      <span>{item.name}</span>
                    </div>
                  </td>

                  <td>{item.role}</td>
                  <td>{item.course}</td>

                  {/* STATUS */}
                  <td>
                    <span style={{ ...badge, ...getStatusStyle(item.status) }}>
                      {item.status}
                    </span>
                  </td>

                  <td>{item.score || "-"}</td>
                  <td>{item.date || "-"}</td>
                  <td>{item.feedback || "-"}</td>
                  <td>{item.attempts || "-"}</td>

                  {/* CERTIFICATE */}
                  <td>
                    {item.certificate ? (
                      <span style={certificateBadge}>
                        ● Issued
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
}

/* STYLES */

const dropdownStyle = {
  background: "#fff",
  border: "1px solid #ddd",
  fontSize: 13,
};

const rowFlex = {
  display: "flex",
  alignItems: "center",
  gap: 10,
};

const avatar = {
  width: 35,
  height: 35,
  borderRadius: "50%",
};

const badge = {
  padding: "4px 10px",
  borderRadius: 6,
  fontSize: 12,
};

const certificateBadge = {
  background: "#22c55e",
  color: "#fff",
  padding: "4px 10px",
  borderRadius: 6,
  fontSize: 12,
};